import { Injectable } from '@angular/core';
import { Request } from '@core/models/requests.model';
import { Fuentes } from '@core/interfaces/catalogos.intefaces';
@Injectable({
  providedIn: 'root'
})
export class FuentesService {

  private url = `ventas/catalogos/segmentacion/fuente/search`;

  constructor(
    private request:Request
  ) { }

  getFuentes(body:any) {
    const options = { headers: this.request.headers };
    return this.request.Post<Fuentes>( this.url,body, options);
  }

  formatValues(data: any[], keyProp: string, valueProp: string): { key: any; value: any }[] {
    return data.map(item => ({ key: item[keyProp], value: item[valueProp] }));
  }
}
